import React from 'react';
import './Termscondition.css';
import Header from './Header';
import Footer from './Footer';

const Termsconditions = () => {
    return (
        <div>
            <Header />
            <div className="nd-terms-page">
                <div className="nd-terms-container container">
                    <div className="nd-terms-hero">
                        <div className="nd-terms-badge">Legal & Compliance</div>
                        <h1 className="nd-terms-title">Terms and Conditions</h1>
                    </div>

                    <div className="nd-terms-lead-card">
                        <p>These Terms and Conditions ("Agreement") govern your use of N D Techland Private Limited ("we," "us," "our") services, including the N D Connect platform ("Service"). By accessing or using our Service, you agree to be bound by these Terms. If you do not agree, you should immediately stop using the Service.</p>
                    </div>

                    <div className="nd-terms-cards-stack">
                        {/* Section 1 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">01</span>
                                <h5><strong>1. Acceptance of Terms</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>By registering for, accessing, or using N D Connect, you accept and agree to be bound by these Terms and Conditions, along with any other policies referenced herein. You must be at least 18 years old to use our services.</p>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">02</span>
                                <h5><strong>2. Modifications to Terms</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>We reserve the right to change, modify, or update these Terms at any time. Any changes will be effective immediately upon posting. Your continued use of the Service after such changes constitutes your acceptance of the updated Terms. We encourage you to periodically review these Terms.</p>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">03</span>
                                <h5><strong>3. Services Provided</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>N D Connect is an all-in-one business software solution designed to streamline operations such as customer management, invoicing, employee tracking, payment reminders, attendance, and more. We offer both web-based and mobile applications for your convenience.</p>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">04</span>
                                <h5><strong>4. User Accounts</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>4.1 Account Registration</strong></h6>
                                    <p>You must provide accurate, complete, and current information when registering for an account on N D Connect. You are responsible for safeguarding your password and for any activities or actions under your account. If you discover any unauthorized access or use of your account, you must notify us immediately.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>4.2 User Responsibility</strong></h6>
                                    <p>You agree to:</p>
                                    <ul className="nd-terms-list">
                                        <li><span className="nd-terms-list-dot"></span>Provide accurate and updated information.</li>
                                        <li><span className="nd-terms-list-dot"></span>Keep your login credentials confidential.</li>
                                        <li><span className="nd-terms-list-dot"></span>Be responsible for all activities conducted through your account.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Section 5 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">05</span>
                                <h5><strong>5. Use of Services</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>5.1 Permitted Use</strong></h6>
                                    <p>You agree to use N D Connect solely for lawful business operations. You are prohibited from using the Service for any illegal or unauthorized purposes.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>5.2 Prohibited Use</strong></h6>
                                    <p>You may not:</p>
                                    <ul className="nd-terms-list">
                                        <li><span className="nd-terms-list-dot"></span>Engage in any fraudulent or illegal activities.</li>
                                        <li><span className="nd-terms-list-dot"></span>Copy, modify, or distribute any part of the Service without authorization.</li>
                                        <li><span className="nd-terms-list-dot"></span>Attempt to access unauthorized areas of our Service.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Section 6 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">06</span>
                                <h5><strong>6. Payments and Billing</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>6.1 Subscription</strong></h6>
                                    <p>Access to certain features of N D Connect may require a subscription. By subscribing, you agree to pay the applicable fees and charges, including all applicable taxes. Failure to make timely payments may result in suspension or termination of your account.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>6.2 Payment Methods</strong></h6>
                                    <p>We accept payments via credit card, debit card, and other payment methods as listed on our website. You are responsible for maintaining accurate payment information.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 7 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">07</span>
                                <h5><strong>7. Renewal and Cancellation</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>7.1 Auto-Renewal</strong></h6>
                                    <p>Your subscription will automatically renew at the end of each billing cycle unless you cancel before the renewal date. You will be charged the current rate for the following subscription period unless otherwise specified.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>7.2 Cancellation</strong></h6>
                                    <p>You may cancel your subscription at any time, but you will not be entitled to a refund for any unused portion of your subscription.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 8 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">08</span>
                                <h5><strong>8. Intellectual Property</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>8.1 Ownership</strong></h6>
                                    <p>All content, features, and functionality, including but not limited to text, graphics, logos, icons, and images, are the exclusive property of N D Techland Private Limited and are protected by copyright, trademark, and other applicable laws.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>8.2 Limited License</strong></h6>
                                    <p>We grant you a limited, non-exclusive, non-transferable license to access and use N D Connect for business purposes. This license does not allow for resale or distribution of any content or material from our Service.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 9 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">09</span>
                                <h5><strong>9. Data Privacy and Security</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>Your use of the Service is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information. By using the Service, you consent to the collection and use of information as outlined in the Privacy Policy.</p>
                            </div>
                        </div>

                        {/* Section 10 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">10</span>
                                <h5><strong>10. Termination of Service</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>We reserve the right to terminate or suspend your access to N D Connect without prior notice if we determine that you have violated these Terms or engaged in conduct that harms the Service or other users. Upon termination, your access to your account and all related data may be restricted or deleted.</p>
                            </div>
                        </div>

                        {/* Section 11 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">11</span>
                                <h5><strong>11. Disclaimers and Limitation of Liability</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>11.1 Disclaimer of Warranties</strong></h6>
                                    <p>The Service is provided on an "as-is" and "as-available" basis. We make no warranties or representations about the accuracy, reliability, or availability of N D Connect. We disclaim all warranties, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>11.2 Limitation of Liability</strong></h6>
                                    <p>In no event shall N D Techland Private Limited, its affiliates, or its licensors be liable for any indirect, incidental, special, or consequential damages arising out of your use or inability to use the Service.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section 12 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">12</span>
                                <h5><strong>12. Governing Law</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>These Terms and your use of N D Connect are governed by the laws of India. Any disputes arising under these Terms shall be resolved exclusively in the courts located in [Jurisdiction].</p>
                            </div>
                        </div>

                        {/* Section 13 */}
                        <div className="nd-terms-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">13</span>
                                <h5><strong>13. Miscellaneous</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <div className="nd-terms-subitem">
                                    <h6><strong>13.1 Entire Agreement</strong></h6>
                                    <p>These Terms constitute the entire agreement between you and N D Techland Private Limited regarding your use of N D Connect.</p>
                                </div>
                                <div className="nd-terms-subitem">
                                    <h6><strong>13.2 Severability</strong></h6>
                                    <p>If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that the remaining provisions remain in full force and effect.</p>
                                </div>
                            </div>
                        </div>

                        {/* Contact Us Card */}
                        <div className="nd-terms-card nd-terms-contact-card">
                            <div className="nd-terms-card-header">
                                <span className="nd-terms-num">📞</span>
                                <h5><strong>Contact Us</strong></h5>
                            </div>
                            <div className="nd-terms-card-body">
                                <p>If you have any questions or concerns regarding these Terms and Conditions, please contact us at:</p>

                                <div className="nd-terms-contact-grid">
                                    <div className="nd-terms-contact-item">
                                        <span className="nd-terms-contact-label">Company</span>
                                        <span className="nd-terms-contact-val">N D Techland Private Limited</span>
                                    </div>
                                    <div className="nd-terms-contact-item">
                                        <span className="nd-terms-contact-label">Email</span>
                                        <span className="nd-terms-contact-val"><a href="mailto:info@ndtechland.com">info@ndtechland.com</a></span>
                                    </div>
                                    <div className="nd-terms-contact-item">
                                        <span className="nd-terms-contact-label">Phone</span>
                                        <span className="nd-terms-contact-val">+91 8826302378</span>
                                    </div>
                                    <div className="nd-terms-contact-item">
                                        <span className="nd-terms-contact-label">Website</span>
                                        <span className="nd-terms-contact-val"><a href="https://www.ndtechland.com" target="_blank" rel="noopener noreferrer">www.ndtechland.com</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Termsconditions;
